import {LucideCheck, LucideSparkles} from "lucide-react";
import {BOL_PRODUCT_URL} from "../../App";
import {LinkToProduct} from "../../pages/HomePage";
import {GoToProductListingButton} from "./PurchaseCtaSection";

export const HeroSection = () => {
    return (
        <section className="relative overflow-hidden bg-gradient-to-b from-brand-50 via-surface-50 to-surface-50 py-16 lg:py-24">

            {/* Decorative soft glows */}
            <div aria-hidden="true" className="pointer-events-none absolute -top-24 -right-24 h-96 w-96 rounded-full bg-brand-200/50 blur-3xl"/>
            <div aria-hidden="true" className="pointer-events-none absolute -bottom-32 -left-24 h-80 w-80 rounded-full bg-brand-100/60 blur-3xl"/>

            <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row items-center gap-10 md:gap-12">
                    <div className="md:w-1/2">

                        <span className="inline-flex items-center gap-2 rounded-full bg-white/70 backdrop-blur px-4 py-1.5 text-sm font-medium text-brand-700 ring-1 ring-brand-200 shadow-sm">
                            <LucideSparkles className="h-4 w-4 text-brand-500"/>
                            Discreet, hygiënisch &amp; herbruikbaar
                        </span>

                        <h1 className="mt-5 font-display text-4xl md:text-5xl lg:text-6xl leading-tight text-surface-900">
                            Staand Plassen
                            <span className="text-brand-600"> voor vrouwen</span>
                        </h1>

                        <p className="mt-4 text-surface-700 text-lg md:text-xl leading-relaxed">
                            Ervaar echte vrijheid met Peesential — de discrete, hygiënische manier voor vrouwen om staand te plassen.
                        </p>

                        <div className="mt-7 flex flex-wrap gap-3">

                            <GoToProductListingButton
                                linkToProduct={LinkToProduct}
                                buttonText="Koop via Bol.com"
                            />

                            <a
                                href="/#hoe-het-werkt"
                                className="px-6 py-3 rounded-full bg-white text-surface-900 font-medium ring-1 ring-surface-200
                                shadow-sm hover:bg-surface-50 hover:ring-surface-300 transition-all focus-ring"
                            >
                                Hoe Het Werkt
                            </a>
                        </div>
                        <ul className="mt-9 grid grid-cols-2 gap-3 text-sm text-surface-800">

                            <UspItem text="Opvouwbaar & compact"/>
                            <UspItem text="Lekvrije afdichting"/>
                            <UspItem text="Gemakkelijk mee te nemen" />
                            <UspItem text="Simpel om schoon te maken" />

                        </ul>
                    </div>
                    <div className="md:w-1/2 relative">
                        {/* Brand glow behind the product */}
                        <div aria-hidden="true" className="absolute inset-6 -z-10 rounded-full bg-gradient-to-tr from-brand-200/70 to-brand-100/40 blur-3xl"/>
                        <BannerImg />
                    </div>
                </div>
            </div>
        </section>
    );
};

const BannerImg = () => {
    return (
        <img
            src={"Peesential-product-web.png"}
            alt="Woman in pink hoodie holding a Peesential in adventure setting"
            className="relative w-full h-auto drop-shadow-2xl"
            width={800}
        />
    );
};

const UspItem = ({text}) => {
    return (
        <li className="flex items-center gap-2.5 rounded-xl bg-white/60 px-3 py-2.5 ring-1 ring-surface-200/70">
            <span className="flex h-6 w-6 flex-none items-center justify-center rounded-full bg-brand-100">
                <LucideCheck className="h-4 w-4 text-brand-600"/>
            </span>
            <span className="font-medium">{text}</span>
        </li>
    );
};
